import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy, doc, updateDoc, where } from 'firebase/firestore'; 
import { db } from '../firebase';

/**
 * Récupère l'ensemble des documents d'une collection sur Firestore (avec leurs données) 
 * ordonnées par date de création décroissante 
 * @param {*} path 
 * @param {boolean} onlyActive si true, récupère les champs active seulement. 
 * @returns 
 */
export const useFirestoreCollection = (path, onlyActive=true) => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {

    if (!path) {
      setLoader(false); // Arrêter le chargement si le chemin est invalide
      return;
    }

    const collectionRef = collection(db, path);
    
    const collectionQuery = onlyActive ?  query(collectionRef, where("active", "==", true), orderBy("dateCreation", "asc")) : 
      query(collectionRef, orderBy("dateCreation", "asc"))

    const unsubscribe = onSnapshot(
      collectionQuery,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setData(items);
        setLoader(false);
      },
      (error) => {
        console.error("Error fetching collection:", error);
        setLoader(false);
      }
    );

    return () => unsubscribe();
  }, [path]);

  return { data, loader };
};


/**
 * Désactive un document dans Firestore en mettant le champ "active" à false
 * @param {string} collectionPath - Chemin complet de la collection
 * @param {string} documentId - ID du document à désactiver
 * @returns {Promise<void>} Une promesse qui se résout quand l'opération est terminée
 */
export const deactivateDocument = async (collectionPath, documentId) => {
  try {
    const documentRef = doc(db, collectionPath, documentId);
    await updateDoc(documentRef, { active: false });
  } catch (error) {
    throw error; // Permet au composant appelant de gérer les erreurs
  }
};

/**
 * Désactive un document dans Firestore en mettant le champ "active" à false
 * @param {string} collectionPath - Chemin complet de la collection
 * @param {string} documentId - ID du document à désactiver
 * @returns {Promise<void>} Une promesse qui se résout quand l'opération est terminée
 */
export const activateDocument = async (collectionPath, documentId) => {
  try {
    const documentRef = doc(db, collectionPath, documentId);
    await updateDoc(documentRef, { active: true });
  } catch (error) {
    throw error; // Permet au composant appelant de gérer les erreurs
  }
};